import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { withAdsContext } from '../../hocs';
import { adsContextPropType } from '../../utils';
import adLogger from './logger';

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

window.googletag.cmd.push(() => {
  window.googletag.pubads().collapseEmptyDivs();
  window.googletag.pubads().enableSingleRequest();
  window.googletag.enableServices();

  window.googletag.pubads().addEventListener('slotRequested', event => {
    const adId = event.slot.getSlotElementId();
    adLogger(`Peticion del slot ${adId}`);
  });
  window.googletag.pubads().addEventListener('slotOnload', event => {
    const adId = event.slot.getSlotElementId();
    adLogger(`Renderizado del slot ${adId}`);
  });
});

class Advertisment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      containerId: `gpt-${this.props.id || ''}${Math.floor(
        Math.random() * 1000
      )}`
    };
    this.slotRef = React.createRef();
  }

  componentDidMount() {
    const { googletag } = window;

    const existScript = document.getElementById('script-GPT');
    if (!existScript) {
      const script = document.createElement('script');
      script.async = 'async';
      script.id = 'script-GPT';
      script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      document.getElementsByTagName('body')[0].appendChild(script);
      googletag.cmd.push(() => {
        googletag.pubads().collapseEmptyDivs();
      });
    }

    const { containerId } = this.state;
    const { adUnit, sizes, keys } = this.props;
    googletag.cmd.push(() => {
      this.slotRef.current = googletag.defineSlot(adUnit, sizes, containerId);
      this.slotRef.current.setTargeting('pos', [keys]);
      this.slotRef.current.setTargeting('amp', 'false');
      this.slotRef.current.addService(googletag.pubads());
      adLogger(`Define slot ${containerId}`);

      this.props.adsContext.dispatch({ type: 'add', payload: containerId });
    });
  }

  componentWillUnmount() {
    const { googletag } = window;

    adLogger(`Destroy slot ${this.state.containerId}`);
    this.props.adsContext.dispatch({ type: 'destroyAll' });
    googletag.cmd.push(() => {
      googletag.destroySlots();
      googletag.pubads().updateCorrelator();
    });
  }

  render() {
    return <div id={this.state.containerId} className="gpt-container" />;
  }
}

Advertisment.propTypes = {
  adUnit: PropTypes.string.isRequired,
  keys: PropTypes.shape(),
  sizes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  id: PropTypes.string,
  adsContext: adsContextPropType.isRequired
};

Advertisment.defaultProps = {
  id: undefined,
  keys: {}
};

export default withAdsContext(Advertisment);
